import { useCallback, useMemo, useState, type ReactNode } from 'react'

import { BookingContext, EMPTY_BOOKING, type Booking } from './booking'

/** Holds one booking in React state, and nowhere else (M39-Q3). */
export function BookingProvider({
  children,
  initial,
}: {
  children: ReactNode
  /** For page tests that start part-way through the flow. */
  initial?: Partial<Booking>
}): ReactNode {
  const [booking, setBooking] = useState<Booking>(() => ({
    ...EMPTY_BOOKING,
    ...initial,
  }))
  const update = useCallback(
    (patch: Partial<Booking>) => setBooking((b) => ({ ...b, ...patch })),
    [],
  )
  const value = useMemo(() => ({ booking, update }), [booking, update])
  return (
    <BookingContext.Provider value={value}>{children}</BookingContext.Provider>
  )
}
